import {
  Datagrid,
  DateField,
  List,

  TextField,
  TextInput, 
  ReferenceInput,
  SelectInput,
  ReferenceField,
  SimpleForm,
  Edit,
  ArrayInput,
  SimpleFormIterator,
  SingleFieldList,
  ChipField,
  ArrayField,
  BooleanInput,

  NumberField,
  useGetList,
  CreateButton,
  TopToolbar,
  Title,
  Show,
  useCreate,
  useCreateSuggestionContext,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  ReferenceArrayField,

  useRecordContext,
  SelectField,
  Filter,
  FilterForm,
  useNotify,
  Create,
  NumberInput,
} from "react-admin";


import {
  Box,

  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  TextField as TextFieldMui,
  Grid,
  Chip,
} from '@mui/material';
import {
  Divider,
} from '@material-ui/core';
import { HttpClient } from "../../../utils/requests";


import { isMobile} from 'react-device-detect';

import React, { useEffect, useState } from 'react';
import keyBy from 'lodash/keyBy'
import {  Loading, ListContextProvider } from 'react-admin'
import { Link } from 'react-router-dom';

import {
  Card, Tab, Tabs,
} from '@mui/material';


import { ContactCreateCommentButton } from './ContactCreateButton';
import VerifiedIcon from '@mui/icons-material/Verified';
import WarningIcon from '@mui/icons-material/Warning';
import { SERVER } from "../../../constants";
import { ColoredChipField, postRowClick } from "../../needs/Needs";
import { Add } from "@material-ui/icons";
import { Aside } from "../CRMAside";
import { choicesTime } from "../reminder/Reminder";

import { CreateFormActions } from "../../../components/FormActions";
import { DatagridUsersProps } from "../clue/Clue";


const FilterContact = (props) => {

  return (
    <Filter {...props}>
      <ReferenceInput variant="outlined" source="contactCategoryId" reference="contactCategory" >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <TextInput label=" جستجو" source="name" variant="outlined" alwaysOn />
    </Filter>
  )
};


export const ContactList = (props) => (
  //رتبه مخاطب
  <List {...props} perPage={50} sort={{ field: 'order', order: 'ASC' }} filters={<FilterContact />}>
    <Datagrid rowClick="show" {...DatagridUsersProps}>
      <TextField source="order" width="20%" />
      <TextFieldApproved source="name" />
      {/* <TextField source="contactRefId" /> */}
      <ReferenceArrayField label="همکاران" source="users" reference="adminUsers" >
        <SingleFieldList linkType={null}>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>

      <ReferenceField link={null} label="اولویت تماس" source="contactPriorityId" reference="preferCall" >
        <ColoredChipField source="title" select="id" />
      </ReferenceField>

      {/* <ShowButton /> */}
    </Datagrid>
  </List>
);
const TextFieldApproved = ({ record }) => (
  <ul>
    {record.name}&nbsp;
    {record.approved ? <VerifiedIcon fontSize="small" color="#0e79f3" /> : <WarningIcon fontSize="small" color="error" />}
  </ul>
)

export const ContactEdit = (props) => {
  const notify = useNotify();
  const [disableInput, setDisableInput] = useState(false)

  const handlePhoneChange = (event) => {

    HttpClient(SERVER + `/admin/contact/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          setDisableInput(true);
          notify(` مخاطب با این شماره وجود دارد  : ${json.result.name}`, { type: 'warning' });
        }else{
          setDisableInput(false);

        }

      })
      .catch((e) => {
      });

  }
  return (
    <Edit {...props}>
      <SimpleForm variant="outlined" redirect="list" disabled={disableInput} toolbar={!disableInput && <CreateFormActions />}>

        <NumberInput source="order" />
        <TextInput source="name" />
        <ReferenceInput source="contactCategoryId" label="دسته مخاطب" reference="contactCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <BooleanInput source="approved" label="تایید/ عدم تایید - هویت مخاطب" />
        <ArrayInput source="phoneNumbers">
          <SimpleFormIterator inline fullWidth={false}  >
            <TextInput source="number" helperText={false} onChange={handlePhoneChange} />
          </SimpleFormIterator>
        </ArrayInput>

        <Divider></Divider>
        <Divider></Divider>
        <Divider></Divider>

        <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >

        {/* <TextInput source="economicCode" label="کد اقتصادی" variant='outlined' />
    <TextInput source="shenaseMeli" label="شناسه ملی" variant='outlined' /> */}
        <TextInput source="introducer" label="معرف" variant='outlined' />



        {/* <ContactCreateButton type="HAGHIGHI" /> */}

        <TextInput source="meliCode" label="کد ملی" variant='outlined' />
        <TextInput source="description" multiline rows={5} width="50%" />
        <TextInput source="tasvieCond" />

        <TextInput source="address" />
        <TextInput source="postalCode" />
        <TextInput source="email" />

        <ReferenceInput source="customerRatingId" label="رتبه" reference="customerRating">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ReferenceInput source="contactPriorityId" label="اولویت تماس" reference="preferCall">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <ReferenceInput source="customerPriorityId" label="اولویت‌بندی" reference="customerPriority">
          <SelectInput optionText="title" />
        </ReferenceInput>
        </SimpleForm>
    </Edit>
  )
};

const CustomerOfCantactShow = () => {
  const props = useRecordContext();



  const { data,  error, loading } = useGetList(

    'customer',
    // {
    { page: 1, perPage: 100 },
    { field: 'updatedAt', order: 'DESC' },
    { "connectors.objectId": props.id },
    // }
  );
  if (loading) {
    return <Loading />
  }
  if (error) {
    return <p>ERROR: {error}</p>
  }
  return (
    <div>
      {Object.values(data).map(function (el, index) {
        return <Chip key={index} label={el.name} variant="outlined" style={{ margin: "4px" }} />
      })}
      {/* <div>{JSON.stringify(data)}</div> */}
    </div>

  );
}
export const ContactShow = (props) => {
  const [page, setPage] = useState(1);
  // const { permissions } = usePermissions();
  // const createProps = { record: { "contactName": 'myValue' } }
  const [tabIndex, setTabIndex] = useState(0);
  const [filter, setFilter] = useState(false);

  const perPage = 1;
  const { data, ids, total, error } = useGetList(

    'need',
    // {
    
    { page: 1, perPage: 100 },
    { field: 'updatedAt', order: 'DESC' },
    { isArchived: filter,contactId: props.id  },
    
    // }
  );
  const { data: clueData, ids: clueIds, total: clueTotal, loading: cLoading } = useGetList(

    'clue',
    // {
    { page: 1, perPage: 100 },
    { field: 'updatedAt', order: 'DESC' },
    { contact: props.id },
    // }
  );
  const { data: reminderData, ids: reminderIds, total: totalReminder } = useGetList(

    'reminder',
    // {
    { page: 1, perPage: 100 },
    { field: 'updatedAt', order: 'DESC' },
    { contact: props.id },
    // }
  );
  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  if (cLoading) {
    return <Loading />
  }
  if (error) {
    return <p>ERROR: {error}</p>
  }
   const filters = [<BooleanInput optionText="isArchived" alwaysOn label="پایان کار بیشتر از دو روز" source="isArchived" />];
  const filterValues = { isArchived: filter };
  const setFilters = filters => setFilter(filters.isArchived?true:false);

  // const filters = [<BooleanInput optionText="isArchived" alwaysOn label="پایان کار بیشتر از دو روز" source="isArchived" />
  // ];

    return (
    <Show style={{ marginRight: "8px" }}  {...props} variant="outlined" aside={<Aside sx={{ height: "40px" }} />} actions={null}>
       
      <div>
      <div style={{
                          margin: "16px 0px",
                          position: "absolute",
                          left: "10vh",
                          top: "6vh"
                
                }}>
                  <ContactCreateCommentButton contact={props}
                  />
                </div>
        <Box>
   
          <Box>
            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="اطلاعات" />
              <Tab label="سرنخ‌ها" />
              <Tab label="درخواست‌ها" />
              <Tab label="یادآوری‌ها" />
            </Tabs>
          </Box>
          <Box sx={{ padding: 2 }}>
            {tabIndex === 0 && (
              <Box>
                
                <Grid container spacing={2} style={{ marginRight: "16px", marginLeft: "16px" }}>

                  <Grid item xs={6} style={{ fontSize: "20px" }}>
                    <br />
                    {/* {(permissions?.includes(ROLES.ROOT) || permissions?.includes(ROLES.SUPER_ADMIN) || permissions?.includes(ROLES.MANAGER_CRM)) ? */}
                      <EditContactButton /> 
                      {/* <TextField source="name" label="نام" style={{ fontSize: "20pt" }} /> */}
                    {/* } */}
                    <br />

                    <br />
                    <ArrayField source="phoneNumbers" style={{ marginBottom: "8px" }}>
                      <SingleFieldList linkType={false}>
                        <ChipField source="number" variant="outlined" helperText={true} />
                      </SingleFieldList>

                    </ArrayField>
                    <br />

                    <ChipField source="email" helperText={true} variant="outlined" style={{ marginBottom: "16px" }} />
                    <br />
                    شرکت‌ها  <br />
                    <CustomerOfCantactShow style={{ marginBottom: "16px" }} />

                    توضیحات
                    <ChipField source="description" variant="outlined" helperText={true} style={{ marginBottom: "8px" }} />
                    <br />


                  </Grid>
                  <Grid item xs={6} style={{ fontSize: "20px" }}>

                    <br /> <br /><ReferenceArrayField label="همکاران" source="users" reference="adminUsers" >
                      <SingleFieldList linkType={null}>
                        <ChipField source="name" variant="outlined" />
                      </SingleFieldList>
                    </ReferenceArrayField>
                    <br />
                    اولویت تماس <ReferenceField link={null} source="contactPriorityId" reference="preferCall" >
                      <ColoredChipField source="title" select="id" variant="outlined" />
                    </ReferenceField>
                    <br />

                    دسته مخاطب  <ReferenceField link={null} label="دسته مخاطب" source="contactCategoryId" reference="contactCategory" >
                      <ChipField source="title" select="id" variant="outlined" />
                    </ReferenceField>
                    <br />
                    رتبه مخاطب <ReferenceField link={null} source="customerRatingId" reference="customerRating" >
                      <ChipField source="title" select="id" variant="outlined" />
                    </ReferenceField>
                    <br />
                    اولویت‌بندی مخاطب <ReferenceField link={null} source="customerPriorityId" reference="customerPriority" >
                      <ChipField source="title" select="id" variant="outlined" />
                    </ReferenceField>
                    <br />
                    شرایط تسویه
                    <ChipField source="tasvieCond" helperText={true} variant="outlined" />
                    <br />
                    {/* <br />معرف
            <ChipField source="introducer" label="معرف" /> */}

                  </Grid>
                </Grid>

              </Box>
            )}
            {tabIndex === 1 && (
              <Box>

                <CreateClueContactButton />
                <ListContextProvider actions={<ListActions />} value={{
                  data: keyBy(clueData, 'id'),
                  ids: clueIds,
                  total: clueTotal,
                  page,
                  perPage,
                  setPage,
                  currentSort: { field: 'id', order: 'ASC' },
                  basePath: "/clue",
                  resource: 'clue',
                  selectedIds: []
                }}>
                  <div>
                    <Title title="" />
                    {/* <FilterForm filters={filters} /> */}
                    <Card>
                      {/* <CreateButton basePath='/need' record={{"contactName": 'myValue'}} resource="need" size="large" /> */}
                      {/* <CreateButton redirect={(redirectTo, basePath, is, data) => `/need/create?source={"contactName":"ali "}`}
                resource="need"  /> */}
                      {isMobile ? (
                        <Datagrid rowClick="show">
                          {/* <TextField source="contactName" label="تماس گیرنده" />
          <ReferenceField link={null} label="وضعیت تماس" source="callResult" reference="statusCall" >
            <ColoredChipField source="title" select="id" />
          </ReferenceField> */}
                          <ArrayField source="order" label="سفارش">
                            <Datagrid>
                              <TextField label="تعداد" source="count" style={{ fontSize: "8pt" }} />
                              <ReferenceField link={null} label="نوع سفارش" source="productCRM" reference="orderType">
                                <TextField source="title" style={{ fontSize: "8pt" }} />
                              </ReferenceField>
                              <TextField label="تخفیف" source="discount" style={{ fontSize: "8pt" }} />
                            </Datagrid>
                          </ArrayField>
                        </Datagrid>
                      ) : (
                        <Datagrid rowClick="show">
                          <DateField label="زمان تماس" source="callTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          {/* <TextField source="clueRefId" /> */}
                          <ChipField label="ایجاد کننده " source="ownerAdmin.name" select="id" />
                          <TextField source="contactName" label="تماس گیرنده" />

                          <ArrayField source="order" label="سفارش">
                            <Datagrid>
                              <TextField label="تعداد" source="count" style={{ fontSize: "8pt" }} />
                              <ReferenceField link={null} label="نوع بسته" source="typeOfBox" reference="package">
                                <TextField source="title" style={{ fontSize: "8pt" }} />
                              </ReferenceField>
                              <ReferenceField link={null} label="نوع سفارش" source="productCRM" reference="orderType">
                                <TextField source="title" style={{ fontSize: "8pt" }} />
                              </ReferenceField>
                              <TextField label="قیمت" source="price" style={{ fontSize: "8pt" }} />
                              <TextField label="تخفیف" source="discount" style={{ fontSize: "8pt" }} />
                            </Datagrid>
                          </ArrayField>
                          <ReferenceField link={null} label="وضعیت تماس" source="callResult" reference="statusCall" >
                            <ColoredChipField source="title" select="id" />
                          </ReferenceField>
                          <TextField source="title" label="عنوان " />
                        </Datagrid>
                      )}
                    </Card>
                  </div>
                </ListContextProvider>
              </Box>
            )}
            {tabIndex === 2 && (
              <Box>

                <CreateRelatedContactButton />         
                <ListContextProvider actions={<ListActions />} value={{
                  data: keyBy(data, 'id'),
                  ids: ids,
                  total,
                  page,
                  perPage,
                  setPage,
                  filterValues, setFilters,
                  currentSort: { field: 'id', order: 'ASC' },
                  basePath: "/need",
                  resource: 'need',
                  selectedIds: []
                }}>
                  <div>
                    <Title title="Book list" />
                    <FilterForm filters={filters} />
                    <Card>

                      {/* <CreateButton basePath='/need' record={{"contactName": 'myValue'}} resource="need" size="large" /> */}
                      {/* <CreateButton redirect={(redirectTo, basePath, is, data) => `/need/create?source={"contactName":"ali "}`}
                resource="need"  /> */}
                      {isMobile ? (
                        <Datagrid rowClick={postRowClick} >
                          <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
                            <TextField source="title" />
                          </ReferenceField>
                          <ReferenceField link={null} label="وضعیت  " source="statusId" reference="status" >
                            {/* <TextField source="title" style={postRowStyle}/> */}
                            <ColoredChipField source="title" select="id" />
                          </ReferenceField>
                          <NumberField source="refNum" label="کد پیگیری" locales="en" textAlign="left" />

                        </Datagrid>

                      ) : (                        
                        <Datagrid rowClick={postRowClick}>

                          <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
                            <TextField source="title" />
                          </ReferenceField>
                          <ReferenceField link={null} label="واحد گیرنده " source="unitId" reference="unit" >
                            <TextField source="title" />
                          </ReferenceField>
                          <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
                            <TextField source="title" />
                          </ReferenceField>
                          <TextField source="ownerName" label="درخواست کننده" />

                          <DateField source="updatedAt" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          {/* {permissions?.includes(ROLES.SUPER_ADMIN) && <TextField source="contactName" />} */}


                          <NumberField source="refNum" locales="en" label="کد پیگیری" textAlign="left" />

                          <DateField source="dueDate" label="تاریخ تحویل" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          <ReferenceField link={null} label="وضعیت  " source="statusId" reference="status" >
                            <ColoredChipField source="title" select="id" />
                          </ReferenceField>
                        </Datagrid>
                      )}
                    </Card>
                  </div>
                </ListContextProvider>
              </Box>
            )}
            {tabIndex === 3 && (
              <Box>

                <CreateAlarmContactButton />
                <ListContextProvider actions={<ListActions />} value={{
                  data: keyBy(reminderData, 'id'),
                  ids: reminderIds,
                  total: totalReminder,
                  page,
                  perPage,
                  setPage,
                  currentSort: { field: 'id', order: 'ASC' },
                  basePath: "/reminder",
                  resource: 'reminder',
                  selectedIds: []
                }}>
                  <div>
                    <Title title="Book list" />
                    {/* <FilterForm filters={filters} /> */}
                    <Card>
                      {/* <CreateButton basePath='/need' record={{"contactName": 'myValue'}} resource="need" size="large" /> */}
                      {/* <CreateButton redirect={(redirectTo, basePath, is, data) => `/need/create?source={"contactName":"ali "}`}
                resource="need"  /> */}
                      {isMobile ? (
                        <Datagrid rowClick="edit">
                          <TextField source="title" label="عنوان " />
                          <DateField label="زمان پیگیری" source="reminderTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          <SelectField source="reminderPeriod" label="تکرار پیگیری" choices={choicesTime} />

                        </Datagrid>
                      ) : (

                        <Datagrid rowClick="edit" >

                          <ReferenceArrayField label="پیگیری کننده" source="users" reference="adminUsers">
                            <SingleFieldList linkType="show" >
                              <ChipField source="name" />
                            </SingleFieldList>
                          </ReferenceArrayField>


                          <DateField label="زمان پیگیری" source="reminderTime" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
                          {/* <TextField source="description" label="یادداشت" /> */}

                          <SelectField source="reminderPeriod" label="تکرار پیگیری" choices={choicesTime} />
                          {/* source name ?*/}

                          <ReferenceField link={null} source="callType" label="نوع تماس" variant="outlined" reference="preferCall">
                            <ColoredChipField source="title" />
                          </ReferenceField>
                          <TextField source="title" label="عنوان " />

                        </Datagrid>
                      )}
                    </Card>
                  </div>
                </ListContextProvider>
                <br />
                <br />
                <br />
              </Box>
            )}
          </Box>
        </Box>
      </div>
    </Show >
  )
};

export const ContactCreate = (props) => {
  const [contactData, setContactData] = useState({ contact: undefined })
  const [disableInput, setDisableInput] = useState(false)
  const notify = useNotify();
  const [lastOrder, setLastOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (loading) {

      HttpClient(SERVER + `/admin/contactlast`, {
        method: "GET",
      })
        .then(({ headers, json }) => {
          if (json.result) {
            setLastOrder(json.result.lastOrder)
            setLoading(false)
          }
        })
        .catch((e) => {
          console.log("injaa ", e)

        });
    }
  })

  const handlePhoneChange = (event) => {
    // const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);
    HttpClient(SERVER + `/admin/contact/phone/` + event.target.value, {
      method: "GET",
    })
      .then(({ headers, json }) => {
        if (json.result) {
          setContactData(json.result)
          setDisableInput(true)
          // setValue("contactName", json.result.name);
          // form.change("contactName", json.result.name);
          notify(` مخاطب با این شماره وجود دارد  : ${json.result.name}`, { type: 'warning' });

        } else {
          setDisableInput(false)

        }

      })
      .catch((e) => {
      });

  }
  if (loading) {
    return <Loading />
  }

  return (
    <Create {...props} class="flex-column">
      <SimpleForm variant="outlined" redirect="list" disabled={disableInput} toolbar={!disableInput && <CreateFormActions />}>
        <NumberInput source="order" defaultValue={lastOrder} />

        <TextInput source="name" defaultValue={contactData.name} disabled={disableInput} />
        {/* <ContactCreateButton type="HOGHUGHI" /> */}
        <ReferenceInput source="contactCategoryId" label="دسته مخاطب" reference="contactCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ArrayInput source="phoneNumbers">
          <SimpleFormIterator inline fullWidth={false}  >

            <TextInput source="number" helperText={false} onChange={handlePhoneChange} />
          </SimpleFormIterator>
        </ArrayInput>

        <Divider></Divider>
        <Divider></Divider>
        <Divider></Divider>

        <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >

        {/* <TextInput source="economicCode" label="کد اقتصادی" variant='outlined' />
    <TextInput source="shenaseMeli" label="شناسه ملی" variant='outlined' /> */}
        <TextInput source="introducer" label="معرف" variant='outlined' />



        <TextInput source="meliCode" label="کد ملی" variant='outlined' />
        <TextInput source="description" multiline rows={5} width="50%" />
        <TextInput source="tasvieCond" />

        <TextInput source="address" />
        <TextInput source="postalCode" />
        <TextInput source="email" />
        <ReferenceInput source="customerRatingId" label="رتبه مشتری" reference="customerRating">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ReferenceInput source="contactPriorityId" label="اولویت تماس" reference="preferCall">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <ReferenceInput source="customerPriorityId" label="اولویت‌بندی مشتری" reference="customerPriority">
          <SelectInput optionText="title" />
        </ReferenceInput>
      </SimpleForm>
    </Create >
  )
};
const ListActions = (props) => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);


const CreateRelatedContactButton = () => {
  const record = useRecordContext();
  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/need/create',
        state: { record: { contactId: record.id, contactRefNum: record.id } },
      }}
    >
      ایجاد درخواست
    </Button>
  )
};

const CreateClueContactButton = () => {
  const record = useRecordContext();
  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/clue/create',
        state: {
          record: {
            contactName: record.name,
            users: record.users,
            contact: record.id, phoneNumber: record.phoneNumbers[0]?.number
          }
        },
      }}
    >
      ایجاد سرنخ
    </Button>
  )
};
const CreateAlarmContactButton = () => {
  const record = useRecordContext();
  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      component={Link}
      style={{ margin: "20px" }}

      to={{
        pathname: '/reminder/create',
        state: {
          record: {
            contactName: record.name,
            contact: record.id,
            users: record.users,

            phoneNumber: record.phoneNumbers[0]?.number
          }
        },
      }}
    >
      ایجاد یادآوری
    </Button>
  )

};
const EditContactButton = () => {
  const record = useRecordContext();
  return (
    <Button
      // startIcon={<Add />}
      color="secondary" variant="outlined"

      component={Link}
      to={{
        pathname: '/contact/' + record.id,
      }}
    >
      <Typography color="black" style={{ fontSize: "20pt", fontFamily: "IRANSansWeb" }}>
        {record.approved ? <VerifiedIcon fontSize="20pt" color="#0e79f3" /> : <WarningIcon fontSize="20pt" color="error" />}
        {record.name}

      </Typography>
    </Button>
  )
};
export const CreateContactDialog = (props) => {
  const { filter, onCancel, onCreate } = useCreateSuggestionContext();
  const [value, setValue] = React.useState(filter || '');
  const [create] = useCreate();

  const handleSubmit = event => {
    event.preventDefault();
    create(
      'contact',
      {
        name: value,
        // typeOfContact: props.type
      },
      {
        onSuccess: ({ data }) => {
          setValue('');
          onCreate(data);
        },
      }
    );
  };

  return (
    <Dialog open onClose={onCancel}>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextFieldMui
            variant="filled"
            label={props.title}
            value={value}
            onChange={event => setValue(event.target.value)}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button style={{background:"#1d8437 !important"}} type="submit">ایجاد مخاطب</Button>
          <Button onClick={onCancel}>فعلا نه</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
// const FilterNeedContactShow = (props) => {

//   return (
//     <Filter {...props}>
//       <ReferenceInput variant="outlined" label="نوع درخواست " source="needCategoryId" reference="needCategory"  >
//         <SelectInput optionText="title" />
//       </ReferenceInput>
//       <ReferenceInput variant="outlined" label="وضعیت " source="statusId" reference="status" >
//         <SelectInput optionText="title" allowEmpty />
//       </ReferenceInput>
//       <BooleanInput optionText="isArchived" alwaysOn label="پایان کار بیشتر از دو روز" source="isArchived" />
//       <ReferenceInput variant="outlined" label="واحد گیرنده " source="unitId" reference="unit" >
//         <SelectInput optionText="title" />
//       </ReferenceInput>

//       {/* <AutocompleteInput optionText="refNum" alwaysOn/> */}
//     </Filter>
//   )
// };

